import type { Profile, Catalogs } from '../../../../core/interfaces/backend/api_auth/identity-profile.interface';
import type { AuthIdentity } from '../../../../core/interfaces/backend/api_auth/api_auth.interface';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs';
import { ApiAuthService } from './api-auth.service';

@Injectable({ providedIn: 'root' })
export class IdentityProfileService {
  private readonly http = inject(HttpClient);
  private readonly auth = inject(ApiAuthService);
  private readonly endpoint = this.auth.baseUrl + '/api/public/api-auth';
  private options() { return { withCredentials: true, headers: { 'X-CSRF-Protection': '1', Authorization: 'Bearer ' + this.auth.accessToken() } }; }
  profile() { return this.http.get<{data: Profile}>(this.endpoint + '/profile', this.options()).pipe(map(r => r.data)); }
  catalogs() { return this.http.get<{data: Catalogs}>(this.endpoint + '/catalogs', this.options()).pipe(map(r => r.data)); }
  save(profile: Record<string, unknown>) { return this.http.post<{data: AuthIdentity}>(this.endpoint + '/profile', profile, this.options()).pipe(map(r => r.data)); }
  digit(nit: string) { return this.http.get<{data: {digit: string}}>(this.endpoint + '/nit-digit', { ...this.options(), params: { nit } }).pipe(map(r => r.data.digit)); }
}
